import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, select, Store} from '@ngrx/store';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import * as actionsUi from './rollenselektion.actions.ui';
import {PageState} from './rollenselektion.reducer';
import * as actionsVorlagen from '../../../client-ngrx/vorlagen';
import * as actionsVeranstaltungen from '../../../client-ngrx/veranstaltungen';
import * as actionsDisplaysteuerung from '../../../client-ngrx/displaysteuerung';
import * as actionsQsChecks from '../../../client-ngrx/qschecks';
import {Datenquelle} from './rollenselektion.model';
import {GetFunktionsbereicheRollenAlleAction} from '../../../client-ngrx/benutzerverwaltung';
import {getVeranstaltungsId} from './rollenselektion.selectors';


@Injectable()
export class RollenselektionPageUiEffects {

    pageResetBenutzerverwaltung$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , filter((x: actionsUi.PageStateResetAction | actionsUi.RefreshDataAction) => x.datenquelle === Datenquelle.Benutzerverwaltung)
        , map(() => {
            return new GetFunktionsbereicheRollenAlleAction();
        })
    ));

    pageResetVorlagen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , filter((x: actionsUi.PageStateResetAction | actionsUi.RefreshDataAction) => x.datenquelle === Datenquelle.Vorlagen)
        , map(() => {
            return new actionsVorlagen.GetFunktionsbereicheRollenAction();
        })
    ));

    pageResetDiplaysteuerung$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , filter((x: actionsUi.PageStateResetAction | actionsUi.RefreshDataAction) => x.datenquelle === Datenquelle.Displaysteuerung)
        , map(() => {
            return new actionsDisplaysteuerung.GetFunktionsbereicheRollenAction();
        })
    ));

    pageResetVeranstaltung$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , withLatestFrom(this.store.pipe(select(getVeranstaltungsId)))
        , filter(([x, ]: [actionsUi.PageStateResetAction | actionsUi.RefreshDataAction, string]) => x.datenquelle === Datenquelle.Veranstaltung)
        , map(([, veranstaltungsId]) => {
            return new actionsVeranstaltungen.GetVeranstaltungFunktionsbereicheRollenAdminAlleAction(veranstaltungsId);
        })
    ));

    pageResetQsChecks$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , filter((x: actionsUi.PageStateResetAction | actionsUi.RefreshDataAction) => x.datenquelle === Datenquelle.QsChecks)
        , map(() => {
            return new actionsQsChecks.GetFunktionsbereicheRollenAction();
        })
    ));

    constructor(private actions$: Actions,
                private store: Store<PageState>) {
    }
}
